/**
 * @generated SignedSource<<92c427ac9e35289ed93e15c3fa1ac4cb>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SchedulableEntityWithText_iScheduleableEntity",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "employeeId",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "SchedulableUser",
            "abstractKey": null
        }
    ],
    "type": "ISchedulableEntity",
    "abstractKey": "__isISchedulableEntity"
};
node.hash = "7ca9baae8f66b7034d7468972b366383";
export default node;
